import type { Business, Pilar, Service, SocialLink } from '../types/business'

export const business: Business = {
  nome: 'Instituto Amorim',
  profissional: 'Dr. Rafael Amorim',
  especialidade: 'Quiropraxia · Seitai · Saúde Integrativa',
  bio: 'Quiroprata e terapeuta Seitai. Trato dor, fadiga e desconforto digestivo investigando a causa: estrutura corporal, microbiota e metabolismo em um único plano de cuidado.',
  cidade: 'Aracruz · ES',
  endereco: 'Av. Venâncio Flores, 480 — Centro',
  complemento: 'Sala 12 · Aracruz, ES · 29190-040',
  telefoneExibicao: '(27) 97654-3210',
  telefoneE164: '+5527976543210',
  whatsapp: '5527976543210',
  email: 'contato@institutoamorim.com.br',
  site: 'institutoamorim.com.br',
  mapsUrl:
    'https://www.google.com/maps/search/?api=1&query=Av.%20Ven%C3%A2ncio%20Flores%2C%20480%20-%20Centro%2C%20Aracruz%20-%20ES',
  mapaEmbed:
    'https://www.openstreetmap.org/export/embed.html?bbox=-40.2790%2C-19.8250%2C-40.2650%2C-19.8170&layer=mapnik&marker=-19.8210%2C-40.2720',
  logoHorizontal:
    'https://cdn.magicpatterns.com/patterns/generated-images/3a689b40-ee22-4cba-bd9c-009c83a16846.jpg',
  imagemCompartilhamento:
    'https://cdn.magicpatterns.com/patterns/generated-images/bd32b763-88d7-4e50-b33b-d08765a48e28.jpg',
  avatar:
    'https://cdn.magicpatterns.com/patterns/generated-images/812f04ec-27d6-433c-ade9-ef921b2f8eaa.jpg',
  capa: 'https://cdn.magicpatterns.com/patterns/generated-images/812f04ec-27d6-433c-ade9-ef921b2f8eaa.jpg',
  avaliacao: '4,9',
  totalAvaliacoes: '286 avaliações',
  atendimentos: '+3.800 atendimentos',
  horarios: [
    { dias: 'Segunda a quinta', horas: '08h — 20h' },
    { dias: 'Sexta', horas: '08h — 17h' },
    { dias: 'Sábado e domingo', horas: 'Fechado' },
  ],
}

export const numeros = [
  { id: 'anos', valor: '12', descricao: 'anos de prática clínica' },
  { id: 'atendimentos', valor: '3.800+', descricao: 'atendimentos realizados' },
  { id: 'nota', valor: '4,9', descricao: 'nota dos pacientes' },
]

export const pilares: Pilar[] = [
  { id: 'microbiota', titulo: 'Microbiota · Digestão · Inflamação' },
  { id: 'metabolismo', titulo: 'Energia · Metabolismo' },
  { id: 'quiropraxia', titulo: 'Quiropraxia · Seitai' },
]

export const avataresClientes = [
  {
    id: 'paciente-1',
    nome: 'Marcelo',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/9f40d300-a467-4ed6-9207-d6529333efee.jpg',
  },
  {
    id: 'paciente-2',
    nome: 'Renata',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/19799e8c-e43f-47c5-846b-110052158b15.jpg',
  },
  {
    id: 'paciente-3',
    nome: 'Diego',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/250f7177-9af6-4720-bb13-e1d294b37ec8.jpg',
  },
  {
    id: 'paciente-4',
    nome: 'Sônia',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/365e030a-6e2d-4bcb-be1f-100da203e4cd.jpg',
  },
]

export const servicos: Service[] = [
  {
    id: 'quiropraxia-estrutural',
    nome: 'Quiropraxia Estrutural',
    resumo: 'Ajuste da coluna para dor e postura',
    descricao:
      'Avaliação postural completa e ajustes quiropráticos precisos para devolver mobilidade às articulações, aliviar dor cervical e lombar e reorganizar a postura de quem passa o dia sentado.',
    duracao: '50min',
    preco: 'R$ 320',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/a9da7ae3-2c01-4cf0-b5a0-934ab77a9604.jpg',
    imagemAntes:
      'https://cdn.magicpatterns.com/patterns/generated-images/baf28a63-b563-492b-8ebd-7122cfca254c.jpg',
    destaques: [
      'Exame postural fotográfico em cada ciclo',
      'Técnicas de baixa força, sem manobras bruscas',
      'Plano de exercícios para fazer em casa',
    ],
  },
  {
    id: 'seitai',
    nome: 'Seitai Japonês',
    resumo: 'Reequilíbrio do eixo e da pelve',
    descricao:
      'Terapia manual japonesa que trabalha respiração, fáscia e eixo corporal. Indicada para assimetrias de quadril, tensão crônica e aquela sensação de corpo travado ao acordar.',
    duracao: '1h',
    preco: 'R$ 280',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/52b5ce37-090a-403e-8729-f8837e44b6d7.jpg',
    imagemAntes:
      'https://cdn.magicpatterns.com/patterns/generated-images/12b28ad8-cb1e-44bd-90a9-a2838692b5c7.jpg',
    destaques: [
      'Toque suave, sem estalos',
      'Reeducação respiratória incluída',
      'Ótimo complemento à quiropraxia',
    ],
  },
  {
    id: 'microbiota',
    nome: 'Microbiota & Digestão',
    resumo: 'Protocolo para inchaço e inflamação',
    descricao:
      'Investigação da saúde intestinal com anamnese detalhada e exames direcionados. Protocolo alimentar e de suplementação para reduzir inchaço, gases, intestino irregular e inflamação sistêmica.',
    duracao: '1h20',
    preco: 'R$ 390',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/b3841cde-e406-452c-a6cb-4980c01a1392.jpg',
    imagemAntes:
      'https://cdn.magicpatterns.com/patterns/generated-images/468b5442-9e2a-4745-af41-688538dcfbca.jpg',
    destaques: [
      'Mapa de sintomas e gatilhos alimentares',
      'Protocolo de 12 semanas com reavaliação',
      'Acompanhamento por WhatsApp',
    ],
  },
  {
    id: 'metabolismo',
    nome: 'Energia & Metabolismo',
    resumo: 'Menos fadiga, mais disposição',
    descricao:
      'Leitura de composição corporal, rotina de sono e marcadores metabólicos para entender a queda de energia ao longo do dia. Você sai com um plano prático de alimentação, movimento e recuperação.',
    duracao: '1h10',
    preco: 'R$ 360',
    imagem:
      'https://cdn.magicpatterns.com/patterns/generated-images/8d20abe8-260c-4009-8f58-4c96ec6edd90.jpg',
    imagemAntes:
      'https://cdn.magicpatterns.com/patterns/generated-images/445b9e3c-8fc7-4820-a1bb-9329dcf66e44.jpg',
    destaques: [
      'Bioimpedância e metas objetivas',
      'Ajuste de sono e ritmo circadiano',
      'Reavaliação em 6 semanas',
    ],
  },
]

export const redes: SocialLink[] = [
  {
    id: 'instagram',
    rede: 'Instagram',
    usuario: '@dr.rafaelamorim',
    url: 'https://instagram.com/dr.rafaelamorim',
  },
  {
    id: 'youtube',
    rede: 'YouTube',
    usuario: 'Aulas sobre intestino e postura',
    url: 'https://youtube.com/@dr.rafaelamorim',
  },
  {
    id: 'google',
    rede: 'Google Meu Negócio',
    usuario: 'Avaliações de pacientes',
    url: 'https://www.google.com/maps/search/?api=1&query=Instituto%20Amorim%20Aracruz',
  },
]
